module.exports = __webpack_public_path__ + "static/media/icon_video_whisper_bk.0025b6dc.svg";